import styled from 'styled-components';

export const StyledAnchor = styled.a`
  text-decoration: underline;
  cursor: pointer;
`;
